import { getRequest } from '../../services/api';

import type { UserFreeSpinsResponse } from './types';

export async function fetchUserFreeSpins() {
  return getRequest<UserFreeSpinsResponse>('/v2/user/free-spins');
}
